// extracted by mini-css-extract-plugin
module.exports = {"muxPlayerWrapper":"mux_muxPlayerWrapper__Cps3C"};